import { jsx as _jsx } from "react/jsx-runtime";

function SvgUpdate() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.996 2.707a3 3 0 00-4.242 0l-12.25 12.25-2.025 5.645c-.428 1.194.725 2.347 1.918 1.919l5.646-2.025 12.25-12.25a3 3 0 000-4.243l-1.297-1.296zM17.168 4.12a1 1 0 011.414 0l1.297 1.297a1 1 0 010 1.414l-1.317 1.316-2.71-2.71 1.316-1.317zm-2.73 2.73l-9.203 9.203-1.516 4.227 4.227-1.516 9.202-9.203-2.71-2.71z"
    }, void 0)
  }), void 0);
}

export default SvgUpdate;